// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__cfcnX","signatureButtonsRight":"ModalSign_signatureButtonsRight__LyD1Q"};